<template>
  <div>
    <CSidebarNavItem
        :name="$pgettext('event.contract_select.title', 'Events')"
        icon="cip-calendar"
        :to="{ name: 'eventList' }"
    />
    <CSidebarNavItem
        :name="$pgettext('event.contract_select.new', 'New event')"
        icon="cip-plus"
        :class="['c-nav-item-new-event']"
        v-if="canCreateEvent"
        @click.native="openCreateNewEvent"
    />
  </div>
</template>

<script>
export default {
  name: 'Events',
  computed: {
    canCreateEvent() {
      return this.hasPerm('events.create')
    }
  },
  methods: {
    openCreateNewEvent() {
      const parent = this.getParentWithMethod('openCreateNewEvent')
      if (parent) parent.openCreateNewEvent({
        canClose: true,
        isFirstEvent: false,
        contract: null,
      })
      else this.notifyError({text: 'Parent not found'})
    }
  }
}
</script>
